import { ComponentChild, h } from 'preact'
import classnames from 'classnames'
import Checkbox from '../../../control-components/ui-components/Checkbox'
import Phrase from '../../../libs/translationsUtils/phrase'

export type sourcesWithExternalTypes =
  | 'community'
  | 'knowledge_base'
  | 'zendesk'
  | 'salesforce'
  | 'skilljar'
  | 'freshdesk'
  | 'federated'

export interface SourceTab {
  key: sourcesWithExternalTypes
  isEnabled: boolean
}

export type SourceTabsType = SourceTab[]

interface Props {
  title: ComponentChild
  updateSourceTabs: (tab: SourceTabsType) => void
  tabs: SourceTabsType
}

const labelMapping: Record<sourcesWithExternalTypes, JSX.Element> = {
  community: <Phrase m='Forum' p='nav.title.community' />,
  knowledge_base: <Phrase m='Common' p='advanced.search.filter.knowledgebase.category' />,
  zendesk: <Phrase m='Forum' p='federated.search.zendesk' />,
  salesforce: <Phrase m='Forum' p='federated.search.salesforce' />,
  skilljar: <Phrase m='Forum' p='federated.search.skilljar' />,
  freshdesk: <Phrase m='Forum' p='federated.search.freshdesk' />,
  federated: <Phrase m='Forum' p='federated.search.federated' />
}

const SourceTabs = ({ tabs, updateSourceTabs, title }: Props) => {
  const updateTab = (tab: SourceTab, idx: number) => {
    tabs[idx].isEnabled = !tab.isEnabled
    updateSourceTabs(tabs)
  }
  return (
    <div className='instant-search__source-type-filter'>
      <span className='instant-search__filter-title'>{title}</span>
      <ul>
        {tabs.map((tab, idx) => {
          return (
            <li
              key={tab.key}
              className='instant-search__filter-list-item instant-search__source-filter-item'
            >
              <div
                className={classnames('instant-search-filter__label-wrapper', {
                  refined: tab.isEnabled
                })}
              >
                <Checkbox
                  label={labelMapping[tab.key]}
                  onUpdate={() => updateTab(tab, idx)}
                  qaClasses='topic-type-checkbox'
                  checked={tab.isEnabled}
                />
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default SourceTabs
